<template>
  <footer class="footer bg-light pt-4">
    <div class="container">
      <div class="row text-muted">
        <div class="col-12"><b>Copyright © 2020</b> All Rights Reserved.</div>
        <div class="col-12 no-print">Please review the <router-link to="/agreement">User Agreement</router-link>.</div>
        <div class="col-12 no-print">Contact Us at Paul.HarrisOD@gmail.com</div>
      </div>
    </div>
  </footer>

</template>

<script>
  export default {
    name: 'BottomFooter',
  };
</script>

<style lang="scss" scoped>
  .footer {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
  }
  @media print {
    .no-print, .no-print * {
      display: none !important;
    }
  }
</style>
